import store from '@/store'

const alertConfig = {
  warning: {
    title: 'Uyarı',
    type: 'warning',
  },
  error: {
    title: 'Hata',
    type: 'error',
  },
}

export const showAppSnackbar = (message, color = 'warning') => {
  if (!message) {
    return
  }

  const config = alertConfig[color] || alertConfig.warning

  store.commit('SHOW_APP_ALERT', {
    title: config.title,
    message,
    type: config.type,
  })
}
